import { render, staticRenderFns } from "./cuidanResult.vue?vue&type=template&id=c1501a20&scoped=true&"
import script from "./cuidanResult.vue?vue&type=script&lang=js&"
export * from "./cuidanResult.vue?vue&type=script&lang=js&"
import style0 from "./cuidanResult.vue?vue&type=style&index=0&id=c1501a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1501a20",
  null
  
)

export default component.exports